import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useOnboarding } from '@/pages/Onboarding/context';

import { entranceSceneChoices } from '../../choicePanelOptions';
import { GenericScreenLayout } from '../../GenericScreenLayout';

export const EntranceScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/entrance-screne.png`}
      title={'You enter. He sees you.'}
      choices={entranceSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
